import { isRouteErrorResponse, useRouteError } from 'react-router';

/**
 * Data routers catch render errors at the nearest `errorElement`, which would
 * otherwise swallow them before they reach the app's top-level `ErrorBoundary`
 * (and its error tracking). Rethrowing hands the error back to that boundary.
 */
export const RethrowRouteError = () => {
  const error = useRouteError();
  /**
   * Unmatched URLs surface here as 404 responses. `useRoutes` rendered nothing
   * for them, so we keep doing that.
   */
  if (isRouteErrorResponse(error) && error.status === 404) return null;
  throw error;
};
